<template>
  <button type="button"
          class="scroll-to-anchor"
          aria-hidden="true"
          @click="onScrollClick">
    <font-awesome-icon icon="caret-down"></font-awesome-icon>
  </button>
</template>

<script>
export default {
  props: {
    /**
     * List of anchor points to check for and scroll to
     */
    anchors: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    /**
     * Scroll to the first anchor that is visible
     */
    onScrollClick () {
      if ( Array.isArray( this.anchors ) ) {
        const selectors = this.anchors.join( "," );
        const domItems = document.querySelectorAll( selectors );

        if ( domItems?.length > 0 ) {
          // Loop through all DOM items that we have found and scroll to the top
          // of the first item that is visible (if any)
          for ( let index = 0; index < domItems.length; index += 1 ) {
            const item = domItems[index];
            if ( item.offsetParent ) {
              // OffsetParent is only populated if the DOM element is visible on the page
              item.scrollIntoView( {
                block: "start",
                inline: "nearest",
                behavior: "smooth",
              } );

              break;
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.scroll-to-anchor{
  position: fixed;
  right: 40px;
  bottom: 40px;
  border: none;
  border-radius: 100%;
  background-color: @color-primary;
  color: white;
  font-size: 2rem;
  width: 50px;
  height: 50px;
  opacity: 0.5;
  z-index: 9999;

  &:hover{
    opacity: 1;
  }
}
</style>
